// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#root .main section[data-v-84683912]{padding-top:48px}@media only screen and (min-width:960px){#root .main section[data-v-84683912]{padding-top:64px}}@media only screen and (min-width:1264px){#root .main section[data-v-84683912]{padding-top:72px}}@media only screen and (min-width:1904px){#root .main section[data-v-84683912]{padding-top:96px}}*[data-v-84683912]{font-family:anjoman!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
